import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { Order } from 'src/app/models/order';
import { ApiService } from 'src/app/services/api.service';
import { OrderSummaryServiceService } from 'src/app/services/order-summary-service.service';
import { fadeOp, fadeOpInOut, slide } from 'src/app/util/animations.util';
import { MatTable } from '@angular/material/table';
import { SYSTEM } from 'src/app/enums/system.enum';
import { FormBuilder, FormGroup } from '@angular/forms';
import  moment from 'moment';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { UtilityService } from 'src/app/services/utility.service';
import { PAYMENT_STATUS } from 'src/app/enums/payment-status.enum';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
@Component({
  selector: 'app-order-home',
  templateUrl: './order-home.component.html',
  styleUrls: ['./order-home.component.css'],
  animations: [
    fadeOp,
    fadeOpInOut,
    slide
  ]
})
export class OrderHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('listWrapper') listWrapper!: ElementRef;
  @ViewChild('container') container!: ElementRef;
  lang: string = '';
  orders: Order[] = new Array();
  readonly TABLE_COL: string[] = ["ref", "pass", "type", "quantity", "price", "start", "expire", "create", "order_date", "payment", "action"];
  limit: number = 10;
  total: number = 0;
  page: number = 1;
  subscription: Subscription = new Subscription();
  loading: boolean = false;
  error: boolean = false;
  isEmpty: boolean = false;
  searchDataGroup: FormGroup;
  selectedType: any;
  selectedStatus: any;
  status: string;
  search: any;
  isSmallScreen: boolean = false;
  arrayTypes: any[] = [
    {
      title_kh: "ទាំងអស់",
      title_en: "All",
      id: ''
    },
    {
      title_kh: "អង្គរ",
      title_en: "Angkor Wat",
      id: SYSTEM.ANGKOR
    },
    {
      title_kh: "កោះកេរ្តិ៍",
      title_en: "Koh Ker",
      id: SYSTEM.KOHKER
    },
    {
      title_kh: "បេងមាលា",
      title_en: "Beng Mealea",
      id: SYSTEM.BENGMEALEA
    },
    {
      title_kh: "ក្បាលស្ពាន",
      title_en: "Kbal Spean",
      id: SYSTEM.KBALSPEAN
    },
    // {
    //   title_kh: "ចុងគ្នាស",
    //   title_en: "Chong Khneas",
    //   id: SYSTEM.CHONGKHNEAS
    // }
  ]

  arrayStatus: any[] = [
    {
      title_kh: "ទាំងអស់",
      title_en: "All",
      code: "All",
      id: ''
    },
    {
      title_kh: "បានបង់ប្រាក់",
      title_en: "Paid",
      code: PAYMENT_STATUS.PAID,
      id: 'paid'
    },
    {
      title_kh: "កំពុងទូទាត់ប្រាក់",
      title_en: "In Payment",
      code: PAYMENT_STATUS.IN_PAYMENT,
      id: 'in_payment'
    },
    {
      title_kh: "មិនទាន់បង់ប្រាក់",
      title_en: "Unpaid",
      code: PAYMENT_STATUS.UNPAID,
      id: 'unpaid'
    }
  ]

  isDisabledEndDate: boolean = true;

  readonly PAYMENT_STATUS = PAYMENT_STATUS;

  constructor(private router: Router,
    private api: ApiService,
    private orderSummary: OrderSummaryServiceService,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private localStorageService: LocalStorageService,
    private snackbar: MatSnackBar,
    private utilityService: UtilityService,
    private dateAdapter: DateAdapter<any>

  ) {
    this.searchDataGroup = this.formBuilder.group({
      type: [null],
      start_date: [],
      end_date: [],
      status: [null]
    });
    this.loadingService._setLoading();
    let locale = this.utilityService.getLang();
    this.dateAdapter.setLocale(locale);
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.getLocalStorageValue();
    this.init()
    this.orderSummary.update();

    this.searchDataGroup.get('end_date')!.valueChanges.subscribe(value => {

      const startDate = this.searchDataGroup.get('start_date')?.value;

      if (startDate && value && new Date(value) < new Date(startDate)) {
        this.searchDataGroup.get('end_date')?.setValue(startDate);
        this.onSearchChange();
      }
    });
  }

  init(): void {
    this.loadingService._setLoading();
    this.subscription.unsubscribe();
    this.error = false;
    this.patchValue();
  }

  ngAfterViewInit(): void {
    // SmoothScrollbar.init(this.listWrapper.nativeElement);
    // SmoothScrollbar.init(this.container.nativeElement);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 900;
  }

  onRowClick(id: string) {
    if (this.isSmallScreen) {
      this.openViewDetail(id);
    }
  }
  getLocalStorageValue() {
    if (this.lang == '') {
      this.lang = this.localStorageService.get(LocalStorage.LANG);
    }

    if (this.checkLocalStorage) {
      this.search = {
        system: this.getType,
        start_date: this.getStartDate,
        end_date: this.getEndDate,
        status: this.getStatus,
        page: this.getPage,
        limit: this.getLimit,
      }
      this.patchFilterValue();
    }
  }

  patchFilterValue() {
    this.page = parseInt(this.localStorageService.get(LocalStorage.page))
    this.searchDataGroup.get('type')!.setValue(this.arrayTypes.find(element => element.id == this.getType))
    this.searchDataGroup.get('status')!.setValue(this.arrayStatus.find(element => element.id == this.getStatus))
    this.searchDataGroup.get('start_date')!.setValue(this.getStartDate)
    this.searchDataGroup.get('end_date')!.setValue(this.getEndDate)
  }

  get getStartDate() {
    let startdate = this.localStorageService.get(LocalStorage.start_date)
    if (startdate) {
      return startdate
    }
  }

  get getEndDate() {
    let end_date = this.localStorageService.get(LocalStorage.end_date)
    if (end_date) {
      return end_date
    }
  }

  get getPage() {
    let page = this.localStorageService.get(LocalStorage.page)
    if (page) {
      return page
    }
    return 1
  }

  get getLimit() {
    let limit = this.localStorageService.get(LocalStorage.limit)
    if (limit) {
      return limit
    }
    return 10
  }

  get getType() {
    let type = this.localStorageService.get(LocalStorage.type)
    if (type == undefined || type == 'undefined') {
      return ''
    } else {
      return type
    }
  }

  get getStatus() {
    let status = this.localStorageService.get(LocalStorage.status)
    if (status == 'all') {
      return ''
    }
    return status
  }

  get checkLocalStorage() {
    if (this.localStorageService.get(LocalStorage.status)
      || this.localStorageService.get(LocalStorage.type)
      || this.localStorageService.get(LocalStorage.page)
      || this.localStorageService.get(LocalStorage.limit)) {
      return true
    }
    return false;
  }

  updateDataOnChange(table: MatTable<Order>): void {

    this.api.getOrders({ page: this.page * this.limit, limit: this.limit - this.orders.length })
      .subscribe(
        response => {
          if (response.status != STATUS.SUCCESS) {
            this.openErrorSnackbar('MSG.FAILED_GET_ORDER');
            return;
          }
          this.orders.push(...response.data.orders.map((order: any) => {
            order.index = this.page * this.limit;
            return order;
          }));
          table.renderRows();
        }
      )
  }

  // deleteOrder(order: Order, table: MatTable<any>): void {
  //   this.dialog.open(ConfirmComponent, {
  //     width: '450px',
  //     data: {
  //       translate: {
  //         title: "TITLE.DELETE_ORDER",
  //         descriptions: ["MSG.DELETE_ORDER"]
  //       }
  //     }
  //   })
  //   .afterClosed()
  //   .subscribe(response => {
  //     if (!response) return;
  //     this.loadingService.setLoading(true);
  //     this.api.deleteUnpaidOrder(order._id)
  //     .subscribe(
  //       response => {
  //         if (response.status == 1) {
  //           this.orderSummary.update();
  //           this.orders.splice(this.orders.indexOf(order), 1);
  //           this.orders = this.orders.map((order, i) => {
  //             order.index = i + this.page * this.limit - this.limit + 1;
  //             return order;
  //           });
  //           this.isEmpty = this.orders.length == 0;
  //           table.renderRows();
  //           this.updateDataOnChange(table);
  //           return
  //         }
  //       },
  //       console.error,
  //       () => {
  //         this.loadingService.setLoading(false);
  //       }
  //     )
  //   })
  // }

  get pageSize(): number[] {
    return [5, 10, 30, 50, 100, 200]
  }

  get totalOrder(): number {
    return this.orderSummary.total;
  }

  get totalUnpaid(): number {
    return this.orderSummary.unpaid;
  }

  get totalPaid(): number {
    return this.orderSummary.paid;
  }

  get totalInPayment(): number {
    return this.orderSummary?.inpayment || 0;
  }

  onPaginationChange(e: MatPaginator): void {
    this.page = e.pageIndex + 1;
    this.limit = e.pageSize;
    this.onSearchChange()
  }

  onSearchChange() {
    this.loadingService.setLoading(true);
    let body
    body = {
      system: this.searchDataGroup.value?.type?.id ? this.searchDataGroup.value?.type?.id : '',
      start_date: this.searchDataGroup.value.start_date ? moment(this.searchDataGroup.value.start_date).format('YYYY-MM-DD') : '',
      end_date: this.searchDataGroup.value.end_date ? moment(this.searchDataGroup.value.end_date).format('YYYY-MM-DD') : '',
      status: this.searchDataGroup.value?.status?.id ? this.searchDataGroup.value?.status?.id : '',
      page: this.page,
      limit: this.limit
    }

    this.setDataLocalStorage(body)
    this.api.getTicketByType(body).subscribe({
      next: res => {
        if (res.status != STATUS.SUCCESS) {
          this.openErrorSnackbar("MSG.FAILED_GET_ORDER")
          return;
        };
        const pagination = res.data.pagination;
        this.isEmpty = pagination.total == 0;
        this.limit = pagination.limit;
        this.total = pagination.total;
        this.orders = res.data.orders.map((order, i) => {
          order.index = i + this.page * this.limit - this.limit + 1;
          order.isPaid = order.status == PAYMENT_STATUS.PAID;
          return order;
        });
        this.isEmpty = pagination.total == 0;
      },
      error: () => {
        this.openErrorSnackbar("MSG.FAILED_GET_ORDER")
      },
      complete: () => {
        this.loadingService.setLoading(false);
      }
    })
  }

  setDefaultValueType() {
    this.searchDataGroup.get('type').setValue(this.arrayTypes[0]);
  }

  patchValue() {
    let body
    if (this.checkLocalStorage) {
      body = this.search
    } else {
      this.setStatus('');
      this.setDefaultValueType();
      body = {
        page: 1,
        limit: 10
      }
    }

    this.subscription = this.api.getTicketByType(body)
      .subscribe({
        next: response => {
          if (response.status != STATUS.SUCCESS) {
            this.openErrorSnackbar('MSG.FAILED_GET_ORDER');
            return;
          }
          const pagination = response.data.pagination;
          this.orders = response.data.orders.map((order, i) => {
            order.index = i + this.page * this.limit - this.limit + 1;
            order.isPaid = order.status == PAYMENT_STATUS.PAID;
            return order;
          });
          this.isEmpty = pagination.total == 0;
          this.limit = pagination.limit;
          this.total = pagination.total;
        },
        error: error => {
          this.error = true;
          this.loadingService._clearLoading();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }

  setStatus(status: string) {
    this.searchDataGroup.get('status').setValue(this.arrayStatus.find(element => element.id == status));
  }

  setDataLocalStorage(item) {
    this.localStorageService.set(LocalStorage.start_date, item.start_date)
    this.localStorageService.set(LocalStorage.end_date, item.end_date)
    this.localStorageService.set(LocalStorage.type, item.system)
    this.localStorageService.set(LocalStorage.limit, item.limit)
    this.localStorageService.set(LocalStorage.page, item.page)
    this.localStorageService.set(LocalStorage.status, item.status)
  }

  resetPage() {
    this.page = 1
    this.limit = 10
    this.localStorageService.set(LocalStorage.limit, this.limit.toString())
    this.localStorageService.set(LocalStorage.page, this.page.toString())
  }

  openErrorSnackbar(message: string /* Localize String */): void {
    this.snackbar.openFromComponent(SnackbarMessageComponent, {
      data: {
        message
      },
      duration: 2000,
      panelClass: 'bg-warn'
    })
  }

  onResetFilter() {
    this.resetPage()
    this.searchDataGroup.reset();
    this.setDefaultValueType()
    this.setStatus('')
    this.onSearchChange()
  }
  ngOnDestroy(): void {
  }

  getMonth(date: any) {
    return this.utilityService.setDate_dd_MMM_YYYY(date);
  }

  getTicketType(num_day: number) {
    let ticket: any;
    switch (num_day) {
      case 3:
        ticket = "LABEL.THREE_DAYS"
        break;

      case 7:
        ticket = "LABEL.SEVEN_DAYS"
        break;

      default:
        ticket = "LABEL.ONE_DAY"
        break;
    }

    return ticket
  }

  openViewDetail(order_id: string) {
    this.router.navigateByUrl(`/order/view?id=${order_id}`);
  }


  downloadTickets(order: any): void {
    this.loadingService._setLoading();
    this.api.downloadOrderTickets(order._id)
      .subscribe({
        next: response => {
          if (!response || response.constructor != Blob) {
            return;
          }
          this.saveFile(response, order.order_tx_number + '-ticket', 'pdf');
          this.loadingService._clearLoading();
        },
        error: error => {
          this.loadingService._clearLoading();
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }

  saveFile(blob: Blob, filename: string, ext?: string): void {
    const downloader = document.createElement('a');
    const url = URL.createObjectURL(blob);
    downloader.href = url;
    downloader.download = filename + (ext ? '.' + ext : '');
    downloader.click();
    URL.revokeObjectURL(url);
    downloader.remove();
  }
}
